import { ReactFlow, type ReactFlowProps, ReactFlowProvider } from '@xyflow/react';

import { type api, isDefined } from 'common';

import { ReactFlowBackground } from './Background';
import { ReactFlowVersionOverlay, type ReactFlowVersionOverlayProps } from './VersionOverlay';
import { convertFlowToReactFlow } from '../../utils';
import { FlowUiMode, ReactFlowViewProvider } from '../context/context';
import { REACT_FLOW_GRAPH_PROPS } from '../graphProps';

interface ReactFlowOverviewGraphProps extends Partial<ReactFlowProps> {
  flowDefinitionData: api.FlowDefinition.FlowData;
  flowDefinitionOverlayProps?: ReactFlowVersionOverlayProps;
  borderRadiusInPixels?: number;
}

export function ReactFlowOverviewGraph(props: ReactFlowOverviewGraphProps) {
  const {
    flowDefinitionData,
    flowDefinitionOverlayProps,
    borderRadiusInPixels,
    ...reactFlowProps
  } = props;
  const { nodes, edges } = convertFlowToReactFlow(flowDefinitionData);
  return (
    <ReactFlowProvider>
      <ReactFlowViewProvider uiMode={FlowUiMode.ReadOnly} nodes={nodes} edges={edges}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          {...REACT_FLOW_GRAPH_PROPS}
          fitView
          maxZoom={20}
          minZoom={0.05}
          nodesFocusable={false}
          nodesConnectable={false}
          nodesDraggable={false}
          edgesFocusable={false}
          edgesReconnectable={false}
          elementsSelectable={false}
          {...reactFlowProps}
        >
          <ReactFlowBackground borderRadiusInPixels={borderRadiusInPixels} />
          {isDefined(flowDefinitionOverlayProps) && (
            <ReactFlowVersionOverlay {...flowDefinitionOverlayProps} left={16} top={8} />
          )}
        </ReactFlow>
      </ReactFlowViewProvider>
    </ReactFlowProvider>
  );
}
